import Mustache from 'mustache';
import React, {useCallback} from 'react';
import PopupTable, {PopupTableRow} from './PopupTable';
import Typography from '@material-ui/core/Typography';
import PopupCloseButton from './PopupCloseButton';
import theme from '../../../theme';

interface InteractionSpecPopupOptions {
    feature: mapboxgl.MapboxGeoJSONFeature;
    onPopupChange: (popup: MapPopup) => void;
    mapboxStyle: GaiaMapboxStyle | undefined;
}

export default function InteractionSpecPopup({
    mapboxStyle,
    feature,
    onPopupChange,
}: InteractionSpecPopupOptions) {
    if (!mapboxStyle || !mapboxStyle['details-template']) {
        throw new Error(`Could not find details template for ${feature.layer.id}`);
    }

    const template = mapboxStyle['details-template'][feature.layer.id];
    const onCloseClick = useCallback(() => onPopupChange(undefined), [onPopupChange]);

    return <div style={{maxWidth: 400, maxHeight: 400, overflow: 'scroll'}}>
        <PopupCloseButton onClick={onCloseClick} />

        <Typography variant='h6' style={{marginBottom: theme.spacing(0.5)}}>{(
            Mustache.render(template.name, feature.properties) ||
            Mustache.render(template['view-title'], feature.properties)
        )}</Typography>

        <Typography variant='body2'>{(
            Mustache.render(template.subtitle, feature.properties)
        )}</Typography>

        <PopupTable style={{marginTop: theme.spacing(1)}}>
            {template.fields.map(([label, value]) => {
                const __html = Mustache.render(value, feature.properties).trim();
                if (!__html) return null;
                return <PopupTableRow
                    key={label}
                    label={label}
                    dangerouslySetInnerHTML={{__html}}
                />;
            })}
        </PopupTable>

    </div>;


}
